import { useEffect, useState } from "react"
import AsyncSelect from "react-select/async";
import Select from "react-select";
import redirectURL from "../redirectURL";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Info from '../../assets/icons/info.png'
import { getDecoder } from "../common/utils";

const AddTicketForm = (props) => {

    const [ticketNo, setTicketNo] = useState('')
    const [foNo, setFONo] = useState('')
    const [details, setDetails] = useState('')
    const typeOptions = [
        { label: "Error", value: "Error" }
    ]

    const generateTicketNumber = () => {
        const characters = '0123456789';
        let result = 'SNDUT'
        for (let i = 0; i < 6; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return result;
    }

    useEffect(() => {
        setTicketNo(generateTicketNumber())
    }, [])


    const promiseOptions = (inputValue) =>
        new Promise(function (myResolve, myReject) {
            if (inputValue != '' && inputValue.length >= 2) {
                let data = redirectURL.post("/getActiveFONumbers", { query: inputValue.toUpperCase() })
                myResolve(data); // when successful
                myReject(data);  // when error
            }
            else {
                setTimeout(() => {
                    myResolve([]);
                }, 100)
            }
        })
            .then(
                function (value) {
                    return value.data ?? []
                },
                function (error) { /* code if some error */ }
            );

    const handleSaveSubmit = (e) => {
        e.preventDefault()
        try {
            props.setSliderLoader("show-m")
            let query = {
                ticket_no: ticketNo,
                fo_number: foNo.value,
                ticket_text: details,
                email: getDecoder().email
            }
            redirectURL.post("/createTicket", query)
                .then(response => {
                    if (response.data.status === 'success') {
                        props.setSliderLoader("show-n")
                        props.closeAddSlider()
                        props.showSweetAlert(true, response.data.message, "success")
                        setDetails('')
                        setFONo('')
                        setTicketNo('')
                    }
                    else if (response.data.status === "fail") {
                        props.showSweetAlert(true, response.data.message, "danger")
                        props.setSliderLoader("show-n")
                    }
                    else {
                        props.showSweetAlert(true, "Failed to create ticket", "danger")
                        props.setSliderLoader("show-n")
                    }
                })
                .catch(err => {
                    console.log(err)
                    props.setSliderLoader("show-n")
                })
        } catch (err) {
            props.setSliderLoader("show-n")
        }
    }

    return (
        <>
            <form className="" style={{ padding: "20px" }} onSubmit={handleSaveSubmit}>
                <div className="form-group">
                    <label style={{ display: "block", marginBottom: "5px" }}>
                        Ticket No.
                    </label>
                    <input
                        type="text"
                        value={ticketNo}
                        style={{
                            width: "100%",
                            padding: "10px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            backgroundColor: "#e7e7e7",
                        }}
                        readOnly
                        autoComplete='off'
                    />
                </div>
                <div className="form-group">
                    <label style={{ display: "block", marginBottom: "5px" }}>
                        <span style={{ color: "#EB1D54", fontSize: "13px" }}>*</span>&nbsp;FO Number&nbsp;
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-example">Kindly enter a minimum of 2 characters to view FO Number suggestions.</Tooltip>}>
                            <img src={Info} width="16px" style={{ position: "absolute" }} />
                        </OverlayTrigger>
                    </label>
                    <AsyncSelect
                        cacheOptions
                        defaultOptions
                        loadOptions={promiseOptions}
                        onChange={(e) => setFONo(e)}
                    />
                </div>
                {/* <div className="form-group">
                                <label style={{ display: "block", marginBottom: "5px" }}>
                                    <span style={{ color: "#EB1D54", fontSize: "13px" }}>*</span>&nbsp;Ticket Type
                                </label>
                                <Select
                                    className="border-radius-0"
                                    isMulti={false}
                                    value={type}
                                    id="selectedFilter"
                                    style={{ borderRadius: "0px" }}
                                    onChange={e => setType(e)}
                                    options={typeOptions}
                                />
                            </div> */}
                <div className="form-group">
                    <label style={{ display: "block", marginBottom: "5px" }}>
                        <span style={{ color: "#EB1D54", fontSize: "13px" }}>*</span>&nbsp;Description
                    </label>
                    <textarea
                        type="text"
                        value={details}
                        onChange={e => setDetails(e.target.value)}
                        autoComplete='on'
                        required
                        style={{
                            width: "100%",
                            padding: "10px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                        }}
                    />
                </div>
                <div className="form-group" style={{ textAlign: "center" }}>
                    <button type="submit" className="btn btn-success"
                        style={{
                            padding: "8px 14px",
                            border: "none",
                            borderRadius: "4px",
                        }}
                    >Submit
                    </button>
                </div>
            </form>
        </>
    )
}
export default AddTicketForm